export {
  enableShadowDOM,
  shadowDOM,
  enableTableNestedRows,
  tableNestedRows
} from '../../../src/flags/flags';
